import { render, staticRenderFns } from "./TestingTools_speaking.vue?vue&type=template&id=1f166fbc&scoped=true"
import script from "./TestingTools_speaking.vue?vue&type=script&lang=js"
export * from "./TestingTools_speaking.vue?vue&type=script&lang=js"
import style0 from "./TestingTools_speaking.vue?vue&type=style&index=0&id=1f166fbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f166fbc",
  null
  
)

export default component.exports